(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*! MenuSpy v1.3.0 (Jan 31 2018) - http://leocs.me/menuspy/ - Copyright (c) 2018 Leonardo Santos; MIT License */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.MenuSpy = factory());
}(this, (function () { 'use strict';

var utils = {
  extend: function extend(a, b) {
    for (var key in b) {
      if (b.hasOwnProperty(key)) {
        a[key] = b[key];
      }
    }

    return a;
  },

  offset: function offset(el) {
    var rect = el.getBoundingClientRect();

    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset
    };
  },

  scrollTop: function scrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
  },

  addClass: function addClass(el, className) {
    if (el.classList) {
      el.classList.add(className);
    } else {
      var classes = el.className.split(' ');
      var existingIndex = classes.indexOf(className);

      if (existingIndex === -1) {
        classes.push(className);
      }

      el.className = classes.join(' ');
    }
  },

  removeClass: function removeClass(el, className) {
    if (el.classList) {
      el.classList.remove(className);
    } else {
      el.className = el.className.replace(new RegExp(("(^|\\b)" + (className.split(' ').join('|')) + "(\\b|$)"), 'gi'), ' ');
    }
  },

  debounce: function debounce(fn, delay) {
    var timeout = null;
    return function() {
      var args = arguments;
      var context = this;
      if (!timeout) {
        timeout = setTimeout(function () {
          timeout = 0;
          return fn.apply(context, args);
        }, delay);
      }
    };
  }
};

var MenuSpy = function MenuSpy(element, options) {
  var this$1 = this;

  if (!element) {
    return;
  }

  var defaults = {
    menuItemSelector : 'a[href^="#"]',
    activeClass      : 'active',
    threshold        : 15,
    enableLocationHash : true,
    hashTimeout      : 600,
    callback         : null
  };

  this.element = typeof element === 'string' ? document.querySelector(element) : element;
  this.options = utils.extend(defaults, options);

  this.assignValues();
  this.debouncedAssignValuesFn = utils.debounce(function () { return this$1.assignValues(); });
  window.addEventListener('resize', this.debouncedAssignValuesFn);

  this.debouncedHashFn = utils.debounce(function () {
    var hash = this$1.lastInViewElm ? ("#" + (this$1.lastInViewElm.id)) : '#';
    if (history.replaceState) {
      history.replaceState(null, null, hash);
    } else {
      var st = utils.scrollTop();
      window.location.hash = hash;
      window.scrollTo(0, st);
    }
  }, this.options.hashTimeout);

  this.cacheItems();
  this.scrollFn();
};

MenuSpy.prototype.assignValues = function assignValues () {
  this.currScrollTop = 0;
  this.lastInViewElm = null;
  this.menuHeight = this.element.offsetHeight + this.options.threshold;
  this.menuItems = [].slice.call(this.element.querySelectorAll(this.options.menuItemSelector));
  this.raf = null;
};

MenuSpy.prototype.cacheItems = function cacheItems () {
  this.scrollItems = this.menuItems.map(function (elm) {
    var target = elm.dataset.target ? document.querySelector(elm.dataset.target) : document.getElementById(elm.hash.slice(1));
    if (target) {
      var offset = Math.floor(utils.offset(target).top);
      return { elm: elm, target: target, offset: offset };
    }
    return false;
  });
  this.scrollItems = this.scrollItems.filter(Boolean).sort(function (a, b) { return a.offset - b.offset; });
};

MenuSpy.prototype.tick = function tick () {
  var fromTop = this.currScrollTop + this.menuHeight;
  var inViewElms = this.scrollItems.filter(function (item) { return item.offset < fromTop; });
  this.activateItem(inViewElms.pop());
};

MenuSpy.prototype.activateItem = function activateItem (inViewElm) {
    var this$1 = this;

  var ref = this.options;
    var activeClass = ref.activeClass;
    var callback = ref.callback;

  if (!inViewElm) {
    this.scrollItems.forEach(function (item) { return utils.removeClass(item.elm.parentNode, activeClass); });
    this.lastInViewElm = null;

    if (this.options.enableLocationHash) {
      this.debouncedHashFn();
    }

    return;
  }

  if (this.lastInViewElm !== inViewElm.target) {
    this.lastInViewElm = inViewElm.target;

    this.scrollItems.forEach(function (item) {
      utils.removeClass(item.elm.parentNode, activeClass);

      if (item.target === inViewElm.target) {
        utils.addClass(item.elm.parentNode, activeClass);

        if (typeof callback === 'function') {
          callback.call(this$1, item);
        }

        if (this$1.options.enableLocationHash) {
          this$1.debouncedHashFn();
        }
      }
    });
  }
};

MenuSpy.prototype.scrollFn = function scrollFn () {
  var st = utils.scrollTop();

  if (this.currScrollTop !== st) {
    this.currScrollTop = st;
    this.tick();
  }

  this.raf = window.requestAnimationFrame(this.scrollFn.bind(this));
};

MenuSpy.prototype.destroy = function destroy () {
  if (this.raf) {
    window.cancelAnimationFrame(this.raf);
  }

  window.removeEventListener('resize', this.debouncedAssignValuesFn);
};

return MenuSpy;

})));

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addHref = addHref;
exports.addHrefSelf = addHrefSelf;
function addHref() {
  var links = document.querySelectorAll('.declaration-chapter-p a');
  Array.prototype.forEach.call(links, function (el) {
    var href = String(el.href);
    if (href.startsWith('mailto')) {
      el.setAttribute('target', '_self');
    } else if (href.includes('#')) {
      var anchor = el.href.split('#')[1];
      if (document.getElementById(decodeURI(anchor)) !== null) {
        el.setAttribute('target', '_self');
      } else {
        if (el.href.includes(window.location.hostname)) {
          // el.style.textDecoration = 'line-through';
          el.setAttribute('target', '_self');
        } else {
          el.setAttribute('target', '_blank');
        }
      }
    } else {
      el.setAttribute('target', '_blank');
    }
  });
}
function addHrefSelf() {
  var links = document.querySelectorAll('.back-to-anchor');
  Array.prototype.forEach.call(links, function (el) {
    el.setAttribute('target', '_self');
  });
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collapsable = collapsable;
function collapsable(onCollapseCallbackFn) {
  // Find all collapsable (P)aragraphs and (H)eadlines and add collapsable class
  var collapsableP = document.querySelectorAll('.declaration-chapter-p');
  Array.prototype.forEach.call(collapsableP, function (el) {
    if (el.getAttribute('data-collapsible') === 'true') {
      var previousEl = el.previousElementSibling;
      if (previousEl.classList.contains('declaration-chapter-h')) {
        el.classList.add('collapsible-p');
        previousEl.classList.add('collapsible-h');
      }
    }
  });
  var collapsableH = document.querySelectorAll('.collapsible-h');
  var currentUrlHash = decodeURI(window.location.hash).substr(1);
  function toggleCollapseElement(el) {
    el.classList.toggle('collapsed');
    el.setAttribute('aria-expanded', "".concat((el.getAttribute('aria-expanded') !== 'true').toString()));
    el.nextElementSibling.classList.toggle('show');
    if (el.getAttribute('aria-expanded') === 'true') {
      el.nextElementSibling.removeAttribute('hidden');
    } else {
      el.nextElementSibling.setAttribute('hidden', '');
    }

    // typeof onCollapseCallbackFn === 'function' ? onCollapseCallbackFn() : null;
  }

  /* Find all collapsable (H)eadlines and add clickable functionality */
  Array.prototype.forEach.call(collapsableH, function (el) {
    el.addEventListener('click', eventToggle);
    el.addEventListener('keypress', eventToggle);

    /* check if a given url hash matches an existing collapsed content and expand it on page load */
    if (currentUrlHash === el.getAttribute('id')) {
      toggleCollapseElement(el);
    }
  });
  function eventToggle(ev) {
    if (ev.code === 'Space' || ev.code === 'Enter' || ev.type === 'click') {
      if (ev.code === 'Space') {
        ev.preventDefault();
      }
      var eventTarget = ev.target;
      toggleCollapseElement(eventTarget);
      var anchorId = eventTarget.id;

      // set the anchorId value as url hash when it gets expanded and store the origin hash value
      if (anchorId && eventTarget.classList.contains('collapsed')) {
        // window.location.hash = anchorId;
        history.replaceState(null, null, "#".concat(anchorId));
      }
    }
  }
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyAltAttributes = emptyAltAttributes;
function emptyAltAttributes() {
  try {
    document.querySelectorAll('div.declaration-chapter-p img').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  } catch (err) {
    console.log('error removing alt attribute from img ' + err);
  }
}

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideBrokenImages = hideBrokenImages;
function hideBrokenImages() {
  try {
    document.querySelectorAll('img').forEach(function (img) {
      img.onerror = function () {
        this.parentElement.innerHTML = '<span>' + this.alt + '<span>';
      };
    });
  } catch (err) {
    console.log('error initializing broken images: ' + err);
  }
}

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ieVersion = ieVersion;
function ieVersion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  var rv = -1;
  var re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
  if (msie > 0 || Boolean(navigator.userAgent.match(/Trident.*rv:11\./))) {
    if (isNaN(Number(ua.substring(msie + 5, ua.indexOf('.', msie))))) {
      //For IE 11 >
      if (navigator.appName === 'Netscape') {
        ua = navigator.userAgent;
        if (re.exec(ua) !== null) {
          rv = parseFloat(RegExp.$1);
          return rv;
        }
      } else {
        return 'otherbrowser';
      }
    } else {
      //For < IE11
      return Number(ua.substring(msie + 5, ua.indexOf('.', msie)));
    }
    return false;
  }
  return false;
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stickyMenyInit = stickyMenyInit;
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
function stickyMenyInit() {
  var stickySpan = document.querySelectorAll('.sticky-span');
  Array.prototype.forEach.call(stickySpan, function (el) {
    if (el.innerHTML === '') {
      var stickyLi = el.parentNode.parentNode;
      stickyLi.style.display = 'none';
    }
  });
  var header = document.querySelector('.sticky-menu');
  var sticky = header.offsetTop + 70;
  window.addEventListener('scroll', isSticky);
  function isSticky() {
    if (window.pageYOffset >= sticky) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  }
  var stickyMenuId = document.querySelector('#sticky_menu');
  var menuButtonId = document.querySelector('#menu-button');
  var hamburgerIcon = document.querySelector('#hamburger-icon');
  var navMenu = document.querySelector('#sticky_nav');
  var focusableEls = [];
  var firstEl, lastEl;
  var trapActive = false;
  function trapFocus(ev) {
    if (!trapActive) return;
    if (ev.key === 'Tab') {
      if (focusableEls.length === 0) return;
      if (ev.shiftKey && document.activeElement === firstEl) {
        ev.preventDefault();
        lastEl.focus();
      } else if (!ev.shiftKey && document.activeElement === lastEl) {
        ev.preventDefault();
        firstEl.focus();
      }
    }
    if (ev.key === 'Escape') {
      toggleMenu(false);
    }
  }
  function toggleMenu() {
    var forceState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var isActive = stickyMenuId.classList.contains('mobile-active');
    var shouldOpen = forceState !== null ? forceState : !isActive;
    if (shouldOpen) {
      stickyMenuId.classList.add('mobile-active');
      document.body.style.overflow = 'hidden'; // Scrollen deaktivieren

      hamburgerIcon.textContent = '✕';
      trapActive = true;
      navMenu.setAttribute('aria-hidden', 'false');
      menuButtonId.setAttribute('aria-label', 'Navigation schließen');

      // Fokusfalle vorbereiten
      focusableEls = navMenu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      focusableEls = Array.prototype.slice.call(focusableEls);
      focusableEls.unshift(menuButtonId); // Button als Teil der Fokusgruppe zulassen
      firstEl = focusableEls[0];
      lastEl = focusableEls[focusableEls.length - 1];
      firstEl.focus();
      document.addEventListener('keydown', trapFocus);
    } else {
      stickyMenuId.classList.remove('mobile-active');
      document.body.style.overflow = ''; // Scrollen wieder aktivieren
      hamburgerIcon.textContent = '☰';
      trapActive = false;
      navMenu.setAttribute('aria-hidden', 'true');
      menuButtonId.setAttribute('aria-label', 'Navigation öffnen');
      document.removeEventListener('keydown', trapFocus);
      menuButtonId.focus();
    }
    menuButtonId.setAttribute('aria-expanded', shouldOpen.toString());
  }
  function mobileMenuFunc() {
    menuButtonId.addEventListener('click', function (ev) {
      toggleMenu();
    });
    menuButtonId.addEventListener('keydown', function (ev) {
      if (ev.code === 'Enter' || ev.code === 'Space') {
        ev.preventDefault();
        toggleMenu();
      }
    });
  }
  function closeMenuOnLinkClick() {
    var menuLinks = navMenu.querySelectorAll('a[href^="#"]'); // nur interne Anker

    menuLinks.forEach(function (link) {
      link.addEventListener('click', function (ev) {
        ev.preventDefault(); // Standardverhalten stoppen

        var targetId = link.getAttribute('href');
        var targetElement = document.querySelector(targetId);
        toggleMenu(false); // Menü schließen

        // Leicht verzögern, damit das Menü sichtbar zugeht
        setTimeout(function () {
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth'
            });
          }

          // Optional: Fokus auf Ziel setzen
          targetElement.focus({
            preventScroll: true
          });
        }, 300); // Delay je nach Animation anpassen
      });
    });
  }
  mobileMenuFunc();
  closeMenuOnLinkClick();
}

},{}],8:[function(require,module,exports){
"use strict";

var _menu = require("./components/menu");
var _collapsable = require("./components/collapsable");
var _addHrefBlank = require("./components/add-href-blank");
var _hidebrokenimages = require("./components/hidebrokenimages");
var _ieVersion = require("./components/ie-version");
var _menuspy = _interopRequireDefault(require("menuspy"));
var _emptyAltAttribute = require("./components/empty-alt-attribute");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* Main Javascript */
/*eslint no-unused-vars: off*/

var menuSpy;
function initMenuSpy() {
  if (menuSpy) {
    menuSpy.destroy();
  }
  menuSpy = new _menuspy.default(document.querySelector('#sticky_menu'), {
    enableLocationHash: false,
    callback: function callback(elem) {
      history.replaceState(null, null, "#".concat(elem.target.id));
    }
  }); // eslint-disable-line no-unused-vars
}

/* Load this when the DOM is ready */
function initJs() {
  // removed all .convert-marked identifiers from template.
  // conversion is done at html generation by handlebars helper function (richText)
  // markedConverter();
  (0, _collapsable.collapsable)(initMenuSpy);
  if ((0, _ieVersion.ieVersion)() !== 10) {
    (0, _menu.stickyMenyInit)();
    (0, _hidebrokenimages.hideBrokenImages)();
  }
  (0, _emptyAltAttribute.emptyAltAttributes)();
  (0, _addHrefBlank.addHref)();
  // removeHrefBlank();

  window.scroll(0, 0);
  var anchorLink;
  var anchorElement = document.getElementById(hash);
  if (anchorElement) {
    anchorLink = document.createElement('a');
    anchorLink.setAttribute('href', "#".concat(hash));
    anchorLink.style.cssText = 'display: none';
    document.body.appendChild(anchorLink);
  }
  var htmlElement = document.getElementsByTagName('html')[0];
  htmlElement.style.scrollBehavior = 'smooth';
  setTimeout(function () {
    if (anchorLink) {
      anchorLink.click();
      document.body.removeChild(anchorLink);
    }
    initMenuSpy();
  }, 500);
}
var hash = decodeURI(window.location.hash).substr(1);
// Load this when everything is ready
window.onload = initJs;

},{"./components/add-href-blank":2,"./components/collapsable":3,"./components/empty-alt-attribute":4,"./components/hidebrokenimages":5,"./components/ie-version":6,"./components/menu":7,"menuspy":1}]},{},[8]);
